var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.38 3.213L13.76 1.591a.745.745 0 00-.53-.22.745.745 0 00-.531.22L3.842 10.55l-.108 3.098 2.843-.57 8.804-8.803a.745.745 0 00.219-.53.745.745 0 00-.22-.53zm-4.511-.692l3.427 3.365M3.742 9.606l3.539 3.387",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#008CFF",
    strokeWidth: 1.5
  })));
}
export default SvgEdit;